(function () {
  var d = document;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Cart drawer ---------- */
  var drawer = qs('[data-cart-drawer]');
  function openDrawer() { if (drawer) { drawer.setAttribute('open-state', 'true'); d.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.setAttribute('open-state', 'false'); d.body.style.overflow = ''; } }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function setCount(n) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function refreshCart() {
    return fetch('/?section_id=cart-drawer-content', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = d.createElement('div');
        tmp.innerHTML = html;
        var fresh = qs('[data-cart-content]', tmp);
        var target = qs('[data-cart-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        var c = fresh && fresh.getAttribute('data-count');
        setCount(parseInt(c || '0', 10) || 0);
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX, standard Shopify endpoints) ---------- */
  d.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var missing = qsa('[data-required-prop]', form).filter(function (el) { return !el.value.trim(); });
    var err = qs('[data-prop-error]', form);
    if (missing.length) {
      if (err) err.hidden = false;
      missing[0].focus();
      return;
    }
    if (err) err.hidden = true;
    var btn = qs('[type=submit]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Wird hinzugefügt …'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || 'Fehler');
        return refreshCart().then(openDrawer);
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ---------- Cart line changes ---------- */
  d.addEventListener('click', function (e) {
    var el = e.target.closest('[data-line-change]');
    if (!el) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(el.getAttribute('data-line'), 10), quantity: parseInt(el.getAttribute('data-line-change'), 10) })
    }).then(refreshCart);
  });

  /* ---------- Quantity steppers ---------- */
  d.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty-step]');
    if (!s) return;
    var input = qs('input', s.parentNode);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(s.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
  });

  /* ---------- Galleries ---------- */
  qsa('[data-gallery]').forEach(function (gal) {
    var track = qs('[data-gallery-track]', gal);
    var dots = qsa('[data-gallery-dot]', gal);
    var thumbs = qsa('[data-gallery-thumb]', gal);
    if (!track) return;
    function go(i) {
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      dots.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { go(i); mark(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); mark(i); }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      mark(Math.min(i, Math.max(dots.length, thumbs.length) - 1));
    }, { passive: true });
  });

  /* ---------- Variant selection ---------- */
  qsa('[data-variant-form]').forEach(function (form) {
    var selects = qsa('[data-variant-option]', form);
    if (!selects.length) return;
    var dataEl = qs('[data-variants-json]', form);
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) {}
    var idInput = qs('[data-variant-id]', form);
    var btn = qs('[type=submit]', form);
    var priceNow = qs('[data-price-now]', form);
    var priceWas = qs('[data-price-was]', form);
    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var complete = chosen.every(function (c) { return c !== ''; });
      var match = null;
      if (complete) {
        match = variants.filter(function (v) {
          return (v.options || []).every(function (o, i) { return o === chosen[i]; });
        })[0] || null;
      }
      if (match && idInput) idInput.value = match.id;
      if (btn) {
        if (!complete) {
          btn.disabled = false;
          btn.textContent = 'In den Warenkorb';
        } else {
          btn.disabled = !match || !match.available;
          btn.textContent = !match ? 'Nicht verfügbar' : (match.available ? 'In den Warenkorb' : 'Ausverkauft');
        }
      }
      if (match && priceNow) priceNow.textContent = match.price;
      if (priceWas) {
        if (match && match.compare_at) { priceWas.textContent = match.compare_at; priceWas.style.display = ''; }
        else if (match) { priceWas.style.display = 'none'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  /* ---------- Dog name input: only letters, space, hyphen, apostrophe ---------- */
  qsa('[data-dog-name]').forEach(function (input) {
    var hint = null;
    var sib = input.parentElement ? qsa('[data-dog-name-hint]', input.parentElement) : [];
    if (sib.length) hint = sib[0];
    input.addEventListener('input', function () {
      var original = input.value;
      var cleaned = original.replace(/[^\p{L} \-']/gu, '').slice(0, 15);
      if (cleaned !== original) {
        input.value = cleaned;
        if (hint) hint.hidden = false;
      } else if (hint && cleaned.length === 0) {
        hint.hidden = true;
      }
    });
    input.addEventListener('blur', function () { if (hint) hint.hidden = true; });
  });

  setCount(parseInt((qs('[data-cart-content]') || {}).getAttribute ? (qs('[data-cart-content]').getAttribute('data-count') || '0') : '0', 10) || 0);
})();

/* ---------- Reviews: carousel + local submit ---------- */
(function () {
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  qsa('[data-reviews]').forEach(function (root) {
    var track = root.querySelector('[data-reviews-track]');
    var prev = root.querySelector('[data-reviews-prev]');
    var next = root.querySelector('[data-reviews-next]');
    if (track && prev && next) {
      var step = function () {
        var card = track.querySelector('.rvw__card');
        return card ? card.offsetWidth + 14 : 320;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      /* drag to scroll (desktop) */
      var down = false, startX = 0, startL = 0;
      track.addEventListener('pointerdown', function (e) { down = true; startX = e.clientX; startL = track.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (down) track.scrollLeft = startL - (e.clientX - startX); });
      window.addEventListener('pointerup', function () { down = false; });
    }

    var form = root.querySelector('[data-reviews-form]');
    if (!form) return;
    var picker = form.querySelector('[data-review-stars]');
    var rating = 0;
    if (picker) {
      var btns = qsa('button[data-star]', picker);
      var paint = function (n) { btns.forEach(function (b, i) { b.classList.toggle('on', i < n); }); };
      btns.forEach(function (b) {
        b.addEventListener('click', function () { rating = parseInt(b.getAttribute('data-star'), 10); paint(rating); });
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameEl = form.querySelector('[data-review-name]');
      var textEl = form.querySelector('[data-review-text]');
      var errEl = form.querySelector('[data-review-error]');
      var name = (nameEl.value || '').trim();
      var text = (textEl.value || '').trim();
      if (!name || !text || !rating) { if (errEl) errEl.hidden = false; return; }
      if (errEl) errEl.hidden = true;
      var starSvg = picker.querySelector('svg') ? picker.querySelector('svg').outerHTML : '★';
      var card = document.createElement('article');
      card.className = 'rvw__card';
      var starsHtml = '';
      for (var i = 0; i < 5; i++) starsHtml += '<span class="' + (i < rating ? 'on' : '') + '">' + starSvg + '</span>';
      var stars = document.createElement('span');
      stars.className = 'stars';
      stars.innerHTML = starsHtml;
      var p = document.createElement('p');
      p.className = 'rvw__text';
      p.textContent = '„' + text + '“';
      var n = document.createElement('p');
      n.className = 'rvw__name';
      n.textContent = name + ' ';
      var tag = document.createElement('span');
      tag.textContent = '· neue Bewertung';
      n.appendChild(tag);
      card.appendChild(stars); card.appendChild(p); card.appendChild(n);
      if (track) {
        track.insertBefore(card, track.firstChild);
        track.scrollTo({ left: 0, behavior: 'smooth' });
      }
      var countEl = root.querySelector('[data-review-count]');
      if (countEl && track) countEl.textContent = track.querySelectorAll('.rvw__card').length + ' Bewertungen';
      form.reset();
      rating = 0;
      if (picker) qsa('button[data-star]', picker).forEach(function (b) { b.classList.remove('on'); });
    });
  });
})();
